import React from "react"
import { z } from "zod"
import { FormSpy } from "react-final-form"
import Grid from "@mui/material/Grid"

import Form, { FormProps } from "app/core/components/Form"
import LabeledTextField from "app/core/components/LabeledTextField"

type CopyDialogFormProps<S extends z.ZodType<any, any>> = Omit<FormProps<S>, "onChange"> & {
  onChange: (e: { [field: string]: any }) => void
}

export default function CopyDialogForm<S extends z.ZodType<any, any>>({
  onChange,
  ...props
}: CopyDialogFormProps<S>) {
  return (
    <Form<S> id="copy-dialog-form" {...props}>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <LabeledTextField name="title" label="Email template title" />
        </Grid>
      </Grid>
      <FormSpy subscription={{ values: true }} onChange={(e) => onChange(e.values)} />
    </Form>
  )
}
